import { render, staticRenderFns } from "./GoodsEvaluation.vue?vue&type=template&id=76bc3d28&scoped=true&"
import script from "./GoodsEvaluation.vue?vue&type=script&lang=js&"
export * from "./GoodsEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./GoodsEvaluation.vue?vue&type=style&index=0&id=76bc3d28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bc3d28",
  null
  
)

export default component.exports